import { localeAtom } from '@core/Atoms/Locale/Locale.atom';
import { LeadFormState, LeadFormStateKey, formStateAtom } from '@core/Atoms/Pdp/FormState.atom';
import { postcodeAtom } from '@core/Atoms/Postcode/Postcode.atom';
import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';
import { finCalcInteractedWithAtom } from '@fincalc/Atoms/FinCalcInteractedWith.atom';
import { flagsAtom } from '@growthBookExperimentation/Atoms/Flags.atom';
import { atom } from 'jotai';

import { leadFormFieldsAtom } from './LeadFormFields.atom';

export const initialiseLeadFormAtom = atom(false, (get, set) => {
  // commeting this coz when the fincalc is interacted , we need to reinitialise the form with default values
  // if (get(initialiseLeadFormAtom)) return;

  const fields = get(leadFormFieldsAtom);
  const flags = get(flagsAtom);
  const vehicle = get(currentVehicleAtom)!;
  const values = get(formStateAtom);
  const locale = get(localeAtom);
  const postcode = get(postcodeAtom);
  const isFinCalcInteractedWith = get(finCalcInteractedWithAtom);
  const extraData = { postcode: postcode[locale] };

  // @ts-expect-error - set self typing is broken
  if (fields.length) set(initialiseLeadFormAtom, true);

  const initialValues: LeadFormState = fields.reduce((acc, item) => {
    if (item.defaultValue) {
      acc[item.id as LeadFormStateKey] = item.defaultValue({
        flags,
        vehicle,
        values,
        extraData,
        isFinCalcInteractedWith,
      });
    }
    return acc;
  }, {} as LeadFormState);

  const fieldsToPersist: LeadFormState = fields.reduce((acc, item) => {
    const hasProp = Object.prototype.hasOwnProperty.call(values, item.id);
    if (hasProp) {
      acc[item.id as LeadFormStateKey] = values[item.id as LeadFormStateKey];
    }
    return acc;
  }, {} as LeadFormState);

  set(formStateAtom, { ...fieldsToPersist, ...initialValues });
});
